import * as React from 'react'
import { useActions as useWorkflowActions } from '../../../../context/reports/workflow/useActions'
import { orderByEvent, groupByEvent, timeFrameEvent } from '../../../../utils/eventTracking'
import { TRACKING_EVENT_ORDER_BY, TRACKING_EVENT_GROUP_BY, TRACKING_EVENT_TIME_FRAME } from '../../../../context/reports/workflow/constants'
import { BY_TYPE_OPTIONS } from '../../utils'
import { Sorting, TimeFrame } from '../../../../context/reports/types'
import { MetricsByType } from '../../../../context/reports/workflow/types'

export function useTrackedActions () {
  const { setSortDirection, setByType, setTimeFrame } = useWorkflowActions()

  const trackedOrderBy = React.useCallback(function trackedOrderBy (chartTitle: string) {
    return (value: Sorting) => {
      const chartOrder = value === 'asc' ? 'least to most' : 'most to least'
      orderByEvent({
        chartTitle,
        chartOrder
      }, TRACKING_EVENT_ORDER_BY)
      setSortDirection(value)
    }
  }, [])

  const trackedGroupBy = React.useCallback(function trackedGroupBy (chartTitle: string) {
    return (value: MetricsByType) => {
      groupByEvent({
        chartTitle,
        chartGrouping: BY_TYPE_OPTIONS[value].label
      }, TRACKING_EVENT_GROUP_BY)
      setByType(value)
    }
  }, [])

  const trackedTimeFrame = React.useCallback(function trackedTimeFrame (
    timeFrameOption: TimeFrame,
    startDate: string,
    endDate: string
  ) {
    timeFrameEvent({ timeFrameOption }, TRACKING_EVENT_TIME_FRAME)
    setTimeFrame(timeFrameOption, startDate, endDate)
  }, [])

  return {
    trackedOrderBy,
    trackedGroupBy,
    trackedTimeFrame
  }
}
